@if (form) {
  <div class="customer-info-details-container">
    <div class="details-content">
      <form [formGroup]="civilityForm">
        @if (fidelityEnabled()) {
          @if (!editable) {
            <div class="button-row">
              <ng-casto-button
                class="secondary"
                [faIcon]="faPen"
                [label]="'generic.update' | translate"
                (click)="editable = !editable"
                [loading]="loading"></ng-casto-button>
            </div>
          } @else {
            <div class="button-row">
              <ng-casto-button
                class="primary"
                [faIcon]="faSave"
                label="Enregistrer"
                (click)="submitForm()"
                [loading]="loading"></ng-casto-button>

              <ng-casto-button
                class="secondary"
                [faIcon]="faTrash"
                label="Annuler"
                (click)="resetForm()"
                [loading]="loading"></ng-casto-button>
            </div>
          }
        }

        <div class="form-input">
          <div class="icon">
            <fa-icon [icon]="faRestroom"></fa-icon>
          </div>
          <div class="text">
            <div class="form-column">
              <span class="label-input" [innerHTML]="'customer-info-form.civility-form.civility' | translate"></span>
              @if (isInputRequiredError('civility', 'civility')) {
                <div class="label-input error">Champ requis</div>
              }
              <div class="radio-inputs sentry-mask">
                @for (civilityValue of civilityValues; track civilityValue.value) {
                  <p-radioButton
                    [inputId]="civilityValue.value"
                    [value]="civilityValue.value"
                    formControlName="civility"
                    [disabled]="!editable" />
                  <label
                    [for]="civilityValue.value"
                    [ngClass]="{
                      disabled: !editable,
                    }">
                    {{ civilityValue.name }}
                  </label>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="form-input">
          <div class="icon">
            <fa-icon [icon]="faUser"></fa-icon>
          </div>
          <div class="text">
            <div class="form-line">
              <div class="form-column">
                <div class="label-input">Prénom</div>
                @if (isInputRequiredError('firstname', 'civility')) {
                  <div class="label-input error">Champ requis</div>
                }
                <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="firstname" required />
              </div>
              <div class="form-column">
                <div class="label-input">Nom</div>
                @if (isInputRequiredError('lastname', 'civility')) {
                  <div class="label-input error">Champ requis</div>
                }
                <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="lastname" required />
              </div>
            </div>
          </div>
        </div>
        <div class="form-input">
          <div class="icon">
            <fa-icon [icon]="faEnvelope"></fa-icon>
          </div>
          <div class="text">
            <div class="form-column">
              <div class="label-input">Email</div>
              <input class="sentry-mask" type="email" [readonly]="!editable" formControlName="email" />
            </div>
          </div>
        </div>
        <div class="form-input">
          <div class="icon">
            <fa-icon [icon]="faMobile"></fa-icon>
          </div>
          <div class="text">
            <div class="form-column">
              <div class="label-input">Mobile</div>
              @if (isInputRequiredError('mobile', 'civility')) {
                <div class="label-input error">Champ requis</div>
              }
              <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="mobile" required />
            </div>
          </div>
        </div>
        <div class="form-input">
          <div class="icon">
            <fa-icon [icon]="faLocationArrow"></fa-icon>
          </div>
          <div class="address-form" [formGroup]="addressForm">
            <div class="form-column">
              @if (!editable) {
                <div class="label-input">Adresse</div>
              }

              <div class="form-line">
                @if (isAddressFormControlVisible('num')) {
                  <div class="form-column">
                    @if (editable) {
                      <div class="label-input">Numéro</div>
                    }
                    <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="num" />
                  </div>
                }
                @if (isAddressFormControlVisible('line1')) {
                  <div class="form-column">
                    @if (editable) {
                      <div class="label-input">Adresse (1)</div>
                    }
                    <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="line1" />
                  </div>
                }
              </div>
              <div class="form-line">
                <div class="form-column">
                  @if (editable) {
                    <div class="label-input">Adresse (2)</div>
                  }
                  @if (isAddressFormControlVisible('line2')) {
                    <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="line2" />
                  }
                </div>
              </div>
              <div class="form-line">
                <div class="form-column">
                  @if (editable) {
                    <div class="label-input">Code postal</div>
                  }
                  @if (isAddressFormControlVisible('postalCode')) {
                    <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="postalCode" />
                  }
                </div>

                <div class="form-column">
                  @if (editable) {
                    <div class="label-input">Ville</div>
                  }
                  @if (isAddressFormControlVisible('city')) {
                    <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="city" />
                  }
                </div>
              </div>
              <div class="form-line">
                <div class="form-column">
                  @if (editable) {
                    <div class="label-input">Complément d'adresse</div>
                  }
                  @if (isAddressFormControlVisible('complement')) {
                    <input class="sentry-mask" type="text" [readonly]="!editable" formControlName="complement" />
                  }
                </div>
              </div>
              <div class="form-line">
                <div class="form-column">
                  @if (editable) {
                    <div class="label-input">Pays</div>
                  }
                  @if (isAddressFormControlVisible('country')) {
                    <p-dropdown
                      styleClass="countries-dropdown"
                      formControlName="country"
                      [options]="countries"
                      optionLabel="label"
                      placeholder="Sélectionne le pays"
                      appendTo="body" />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-input">
          <div class="icon">
            <fa-icon [icon]="faCalendar"></fa-icon>
          </div>
          <div class="text">
            <div class="form-column">
              <div class="label-input">Date de naissance</div>
              <p-calendar
                formControlName="birthdate"
                [dateFormat]="'dd-mm-yy'"
                inputId="birthdate"
                placeholder="jj-mm-aaaa">
              </p-calendar>
            </div>
          </div>
        </div>
        <div class="form-input">
          <div class="marketing-consent-form" [formGroup]="marketingConsentForm">
            <ng-casto-marketing-consent-selector
              [marketingConsentFormGroup]="marketingConsentForm"></ng-casto-marketing-consent-selector>
          </div>
        </div>
      </form>
    </div>
  </div>
}
